module.exports = __webpack_public_path__ + "img/About-US.7539dfb7.svg";